import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=65015cd9"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports